<template>
  <!-- 账号管理 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="params" label-width="auto" class="from">
        <el-form-item :label="$t('pages.system.text66')">
          <el-input
            v-model="params.username"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text67')">
          <el-input
            v-model="params.realName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['accountManagement:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['accountManagement:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['accountManagement:add']"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="params.pageSize"
      @currentChange="currentChange"
    >
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="username"
        :label="$t('pages.system.text66')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="realName"
        :label="$t('pages.system.text68')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="departmentName"
        :label="$t('pages.system.text69')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="roleName"
        :label="$t('pages.system.text70')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="createdAT"
        :label="$t('pages.system.text71')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t("public.text4")
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :command="{ type: 'see', data: scope.row }"
                  v-permission="['accountManagement:see']"
                  >{{ $t("button.look") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'edit', data: scope.row }"
                  v-permission="['accountManagement:edit']"
                  >{{ $t("button.edit") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'share', data: scope.row }"
                  v-permission="['accountManagement:share']"
                  >{{ $t("button.sharing") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'resetPassword', data: scope.row }"
                  v-permission="['accountManagement:resetPwd']"
                  >{{ $t("button.resetPassword") }}</el-dropdown-item
                >
                <el-dropdown-item
                  :command="{ type: 'remove', data: scope.row }"
                  v-permission="['accountManagement:remove']"
                  >{{ $t("button.delete") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <AccountManagementAdd
      @dialogClose="dialogClose"
      :dialogVisible="dialogVisible"
      @accountManagementList="accountManagementList"
      :accountManagementAddState="accountManagementAddState"
      :currentAccount="currentAccount"
    />

    <!-- 分享弹窗 -->
    <AccountShareModule
      @shareClose="shareClose"
      :shareVisible="shareVisible"
      :shareInfo="shareInfo"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import AccountManagementAdd from "./module/accountManagementAdd.vue";
import AccountShareModule from "./module/accountShareModule.vue";
import { randomString } from "../../../utils/util/validate";
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentAccount: {}, //当前账号
      accountManagementAddState: 0, //弹窗类型 0：新增 1：编辑 2：查看
      params: {
        belongCustomerId: "", //平台方id
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        realName: "", //姓名
        roleId: "", //角色id
        username: "", //账号
      },
      shareInfo: {}, //分享数据
      total: 0,
      shareVisible: false, //分享弹窗
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    AccountManagementAdd,
    AccountShareModule,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.accountManagementList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.params.pageNum = 1;
      this.total = 0;
      this.accountManagementList();
    },
    //操作
    handleCommand(e) {
      if (e.type == "see") {
        this.see(e.data);
      }
      if (e.type == "edit") {
        this.edit(e.data);
      }
      if (e.type == "share") {
        this.share(e.data);
      }
      if (e.type == "resetPassword") {
        this.resetPassword(e.data);
      }
      if (e.type == "remove") {
        this.remove(e.data);
      }
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //打开分享弹窗
    share(e) {
      this.request.accountManagementShare(e.id).then((res) => {
        this.shareInfo = {
          password: res.data.post,
          username: res.data.username,
          domain: res.data.domain,
        };
        this.shareVisible = true;
      });
    },
    //关闭分享弹窗
    shareClose() {
      this.shareVisible = false;
    },
    //账号管理-列表（分页）
    accountManagementList() {
      this.params.belongCustomerId = this.platformData.id;
      this.request.accountManagementList(this.params).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.params.pageNum = 1;
        this.params.pageSize = 10;
        this.params.realName = "";
        this.params.username = "";
      }
      this.params.pageNum = e;
      this.accountManagementList();
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.total = 0;
      this.params.pageNum = 1;
      this.params.pageSize = 10;
      this.params.realName = "";
      this.params.username = "";
      this.accountManagementList();
    },
    //新增
    add() {
      this.accountManagementAddState = 0;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.request.accountManagementInfo(e.id).then((res) => {
        this.currentAccount = res.data;
        this.accountManagementAddState = 2;
        this.dialogVisible = true;
      });
    },
    //编辑
    edit(e) {
      this.request.accountManagementInfo(e.id).then((res) => {
        this.currentAccount = res.data;
        this.accountManagementAddState = 1;
        this.dialogVisible = true;
      });
    },
    //删除
    remove(e) {
      this.$confirm(this.$t("pages.system.text72"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          this.request.accountManagementDelete(e.id).then(() => {
            this.$message.success(this.$t("public.text7"));
            this.accountManagementList();
          });
        })
        .catch(() => {});
    },
    //重置密码
    resetPassword(e) {
      let newPassword = randomString(6);
      this.request
        .accountManagementResetPassword({ id: e.id, password: newPassword })
        .then(() => {
          this.$message.success(this.$t("pages.system.text73"));
          this.$alert(
            `${this.$t("pages.system.text74")}:${newPassword}`,
            this.$t("pages.system.text74"),
            {
              confirmButtonText: this.$t("button.determine"),
              callback: () => {
                this.accountManagementList();
              },
            }
          );
        });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>